<script>
import Base from '@/plans/ROOM_CONNECTOR/config/base';
import addonMixin from '@/plans/mx/addon';
import { mapGetters } from 'vuex';
import { DEFAULT_MIN_HOST } from '@/common/constants';

export default {
  name: 'RoomConnectorEdit',
  extends: Base,
  mixins: [addonMixin],
  data() {
    return {
      showCycleAlert: true,
      showBoughtLicense: true,
    };
  },
  computed: {
    ...mapGetters(['basicConfig', 'currentEditPlan']),
    disabledForBulkLicense() {
      return (cycle) => {
        return this.basicConfig?.isBulkLicenseAccount && this.currentEditPlan?.billing_cycle !== cycle;
      };
    },
    previousQuantity() {
      return this.currentEditPlan?.cartInfo?.selected_number ?? DEFAULT_MIN_HOST;
    },
    minHosts() {
      if (this.disableDownSell || !this.isStandardPrice) return this.previousQuantity;
      return this.mx_minHosts;
    },
    maxHosts() {
      const editMaxQuantity = 9999;
      const quantity = this.currentEditPlan?.cartInfo?.selected_number;
      return quantity <= editMaxQuantity ? editMaxQuantity : quantity;
    },
    disableDownSell(){
      return this.basicConfig.downSellData.disableDownSell;
    },
    decreaseTips() {
      if (this.selectedNumber === this.previousQuantity) {
        if(this.disableDownSell) {
          return this.$t('billing.error.can_not_bought_plan_tips');
        }
        if (this.forNonStandardPriceTips) {
          return this.forNonStandardPriceTips;
        }
      }
      return ''
    },
  },
  watch: {
    selectedNumber: {
      handler() {
        this.$nextTick(() => {
          this.mx_validDownSellLicense(this.selectedNumber);
        });
      },
      deep: true
    }
  },
};
</script>
